
import React from "react";

import FileUploadList from "../component/FileUploadList";

const FileUploadListContainer = () => (<FileUploadList />)

export default FileUploadListContainer; 